module.exports = __webpack_public_path__ + "static/img/02344_3.f220b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_3.jpg
// module id = OD2i
// module chunks = 1